import { useTranslation } from 'src/core/common/hooks/useTranslation';

type AccountingSoftwareOption = {
  key: string | 'other';
  label: string;
};

export const useAccountingSoftwareOptions = (): AccountingSoftwareOption[] => {
  const { t } = useTranslation('global');
  const other = t('exports.accountingsSoftwareOther');

  return [
    ...options.map((label) => ({
      key: label,
      label,
    })),
    {
      key: 'Other',
      label: other,
    },
  ];
};

const options = [
  'ACD',
  'Agicap',
  'Campfire',
  'Cegid EBP Compta',
  'Cegid Expert',
  'Cegid Loop',
  'Cegid Quadra',
  'Cegid XRP',
  'DATEV',
  'Exact Globe',
  'Exact Online',
  'Fulll',
  'Holded',
  'Inqom',
  'Microsoft Dynamics 365 Business Central',
  'Microsoft Dynamics 365 Finance',
  'Odoo',
  'Oracle Financials',
  'Oracle Fusion',
  'Oracle NetSuite',
  'Pennylane',
  'QuickBooks Online',
  'Rillet',
  'SAP Business One',
  'SAP R/3',
  'SAP S/4HANA',
  'Sage 100',
  'Sage 200',
  'Sage 300',
  'Sage 50',
  'Sage Generation Experts Connect',
  'Sage Intacct',
  'Sage X3',
  'Twinfield',
  'Workday Financial Management',
  'Xero',
];
